// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kIgc","title":"Header_title__1yHA2","side":"Header_side__3vrAj"};